export default __webpack_public_path__ + "static/media/Path3523.9138152b.svg";